import styles from './style.postcss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'omni-common-ui';
import { actions as userActions, accessors as UserAccessors } from 'data/Users';
import is from 'is_js';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export class UserInfo extends Component {
  componentDidMount() {
    this._setUp(this.props);
  }

  componentWillReceiveProps(props) {
    this._setUp(props);
  }

  _setUp(props) {
    if (is.not.empty(props.id)) {
      props.fetchUserIfNeeded(props.id);
    }
  }

  _renderDate(dateStr) {
    if (is.existy(dateStr)) {
      return <div className={styles.UserInfo_date}>{dateStr}</div>;
    }
    return null;
  }

  render() {
    const { user, dateStr } = this.props;
    if (! user) return null;

    return <div className={classnames(this.props.className)}>
      <div className={styles.UserInfo_name}>
        {`${user.firstName} ${user.lastName}'s Comment`}
      </div>
      {this._renderDate(dateStr)}
    </div>;
  }
}

UserInfo.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  fetchUserIfNeeded: PropTypes.func,
  isLoading: PropTypes.bool,
  user: PropTypes.shape(),
  dateStr: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  return {
    user: UserAccessors.getUserByUserId(state, ownProps.id),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(userActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanApprovalView/UserInfo/index.jsx